import notEmptyAttribute from '@model/_shared/validator/notEmptyAttribute'

export const validators = {
  installationDate: notEmptyAttribute,
  name: notEmptyAttribute,
}

export {
  validators as default,
  notEmptyAttribute,
}
